export const getFoodsAndRecipesPageSteps = (t) => [
    {
        target: '[data-tour="far-header"]',
        placement: 'bottom',
        title: t('tour.foodsAndRecipesPage.step-welcome-title'),
        content: t('tour.foodsAndRecipesPage.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="far-tabs"]',
        title: t('tour.foodsAndRecipesPage.step-tabs-title'),
        content: t('tour.foodsAndRecipesPage.step-tabs-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="far-recipes"]',
        title: t('tour.foodsAndRecipesPage.step-recipes-title'),
        content: t('tour.foodsAndRecipesPage.step-recipes-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="far-foods"]',
        title: t('tour.foodsAndRecipesPage.step-foods-title'),
        content: t('tour.foodsAndRecipesPage.step-foods-content'),
        disableBeacon: true,
    },
];
